// extracted by mini-css-extract-plugin
module.exports = {"root":"our-commitment_root__0g5Nv","statsSectionContainer":"our-commitment_statsSectionContainer__VQ2T_"};